import React, { useState } from 'react';
import { Card, Form, Button } from 'react-bootstrap';

const UserForm = ({ onAdd }) => {
  const [formData, setFormData] = useState({
    name: '',
    username: '',
    phone: '',
    password: '',
    type: 'user'
  });

  const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = async e => {
    e.preventDefault();
    const success = await onAdd(formData);
    if (success) {
      setFormData({ name: '', username: '', phone: '', password: '', type: 'user' });
    }
  };

  return (
    <Card className="border-0 shadow-sm bg-light">
      <Card.Body>
        <h6 className="card-title text-uppercase small font-weight-bold mb-3 text-muted">Add New User</h6>
        <Form onSubmit={onSubmit}>
          <Form.Group className="mb-2">
            <Form.Label className="small font-weight-bold">Full Name</Form.Label>
            <Form.Control 
              type="text" name="name" 
              value={formData.name} onChange={onChange} 
              size="sm" required 
            />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label className="small font-weight-bold">Username</Form.Label>
            <Form.Control 
              type="text" name="username" 
              value={formData.username} onChange={onChange} 
              size="sm" placeholder="Optional"
            />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label className="small font-weight-bold">Phone Number</Form.Label>
            <Form.Control 
              type="text" name="phone" 
              value={formData.phone} onChange={onChange} 
              size="sm" placeholder="Optional"
            />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label className="small font-weight-bold">Temporary Password</Form.Label>
            <Form.Control 
              type="password" name="password" 
              value={formData.password} onChange={onChange} 
              size="sm" required 
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label className="small font-weight-bold">Role</Form.Label>
            <Form.Control as="select" name="type" value={formData.type} onChange={onChange} size="sm">
              <option value="user">Standard User</option>
              <option value="admin">Administrator</option>
            </Form.Control>
          </Form.Group>
          <Button type="submit" variant="primary" size="sm" block className="font-weight-bold">
            Add User
          </Button>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default UserForm;
